import IUser from "../../interfaces/iuser.type";

export default class User {
   private readonly id: string;
   private readonly username: string | undefined;
   private readonly email: string | undefined;
   private readonly firstName: string | undefined;
   private readonly lastName: string | undefined;
   private readonly displayName: string | undefined;
   private readonly verifiedEmail: boolean;
   private readonly roles: string[] | undefined;
   private readonly properties: object | undefined;
   private readonly phoneNumber: string | undefined;
   private readonly phoneVerified: boolean;
   private readonly created: string | undefined;
   private readonly contractIds: object[] | undefined;
   private readonly authTypes: string[] | undefined;

   constructor(
      userProperties: IUser
   ) {
      this.id = userProperties.id;
      this.username = userProperties.username;
      this.email = userProperties.email;
      this.firstName = userProperties.firstName;
      this.lastName = userProperties.lastName;
      this.displayName = userProperties.displayName;
      this.verifiedEmail = userProperties.verifiedEmail;
      this.roles = userProperties.roles;
      this.properties = userProperties.properties;
      this.phoneNumber = userProperties.phoneNumber;
      this.phoneVerified = userProperties.phoneVerified;
      this.created = userProperties.created;
      this.contractIds = userProperties.contractIds;
      this.authTypes = userProperties.authTypes;
   }

   getId = () => this.id;
   getUsername = () => this.username;
   getEmail = () => this.email;
   getFirstName = () => this.firstName;
   getLastName = () => this.lastName;
   getDisplayName = () => this.displayName;
   getVerifiedEmail = () => this.verifiedEmail;
   getRoles = () => this.roles;
   getProperties = () => this.properties;
   getPhoneNumber = () => this.phoneNumber;
   getPhoneVerified = () => this.phoneVerified;
   getCreated = () => this.created;
   getAuthTypes = () => this.authTypes;
   getContractIds = () => this.contractIds;
   getFullName = () => this.firstName && this.lastName ? `${this.firstName} ${this.lastName}` : undefined;
   toObject = () => ({
      id: this.getId(),
      username: this.getUsername(),
      email: this.getEmail(),
      firstName: this.getFirstName(),
      lastName: this.getLastName(),
      displayName: this.getDisplayName(),
      verifiedEmail: this.getVerifiedEmail(),
      roles: this.getRoles(),
      properties: this.getProperties(),
      phoneNumber: this.getPhoneNumber(),
      phoneVerified: this.getPhoneVerified(),
      created: this.getCreated(),
      authTypes: this.getAuthTypes(),
      contractIds: this.getContractIds(),
      fullName: this.getFullName()
   });
};
